<template>
  <div>
    <div class="panel">
      <div class="panel-section">
        <countdown-timer start-date-string="2025-05-02T00:00:00-0700"
                        target-date-string="2025-05-06T09:00:00-0700" 
                        header-text="<span style='color: #E39A4D;'>TechX</span> day 1 is in:" 
                        footer-text="Register today!"
                        target-url="https://conferences.autodesk.com/flow/autodesk/techx2025/sessioncatalog/page/digital/session/1743714919617001AQBx"/>
        <countdown-timer start-date-string="2025-05-06T10:00:00-0700" 
                        target-date-string="2025-05-07T09:00:00-0700" 
                        header-text="<span style='color: #E39A4D;'>TechX</span> day 2 is in:" 
                        target-url="https://conferences.autodesk.com/flow/autodesk/techx2025/sessioncatalog/page/digital/session/1743714967721001DdQS"/>
      </div>
      <div class="panel-section">
        <popular-apps />
      </div>
      <div class="panel-section">
        <my-content ref="myContent" />
      </div>
      <div class="panel-section">
        <bookmarks />
      </div>
      <div class="panel-section">
        <events />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PopularApps from "./PopularApps";
import Bookmarks from "./Bookmarks";
import Events from "./events/Events";
import MyContent from "./MyContent";
import CountdownTimer from "./CountdownTimer";
import * as CONSTANTS from "@/store/constants";

export default {
  name: "right-panel",
  components: {
    CountdownTimer, // Register the new component
    Bookmarks,
    PopularApps,
    Events,
    MyContent,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    // impersonation
    "user.userName": function () {
      this.$refs.myContent.initializeContent();
    },
  },
};
</script>

<style scoped>
.loading-skeleton {
  min-height: 800px;
}
.panel {
  padding-top: 19px;
  padding-left: 2.2rem;
  padding-right: 2.2rem;
  font-family: 'artifaktElementRegular', Arial, sans-serif; /* Apply font globally */
}
.panel-section {
  padding-bottom: 1.2rem;
  font-family: 'artifaktElementRegular', Arial, sans-serif;
}

@media (max-width: 992px) {
  .panel {
    padding-left: 2.0rem;
    padding-right: 2.0rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/RightPanel.vue